import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createFragmentContainer, graphql } from 'react-relay';
import { addAndApplyFilter } from '../../../actions/filterActions';
import { VALID_DIMENSION_FILTERS } from '../sbSharedRefineMenuConstants';

// components
import { SbSharedRefineMenuInputRange } from './SbSharedRefineMenuInputRange';
import { SbSharedRefineMenuDimensionFacet } from '../SbSharedRefineMenuDimensionFacet/SbSharedRefineMenuDimensionFacet';
import { SbSharedMeasurementUnitProvider } from '../../SbSharedMeasurementUnitProvider/SbSharedMeasurementUnitProvider';
import { SbSharedRefineMenuDimensionUnitRadioSelect } from '../SbSharedRefineMenuDimensionUnitRadioSelect/SbSharedRefineMenuDimensionUnitRadioSelect';

export const SbSharedRefineMenuInputRangeDimensionsComponent = props => {
    const {
        user,
        size,
        filters,
        applyOnBlur,
        searchBrowse,
        onApplyCallback,
        showInvalidRangeErrorMessage,
    } = props;
    const dimensionFilters = filters.filter(dimensionFilter =>
        VALID_DIMENSION_FILTERS.includes(dimensionFilter.name)
    );

    return (
        <SbSharedMeasurementUnitProvider user={user} searchBrowse={searchBrowse}>
            {({ measurementUnit }) => (
                <React.Fragment>
                    <SbSharedRefineMenuDimensionUnitRadioSelect
                        user={user}
                        searchBrowse={searchBrowse}
                        selectedMeasurementUnit={measurementUnit}
                    />
                    {dimensionFilters.map(dimensionFilter => {
                        const { localizedFilterName, name } = dimensionFilter;
                        return (
                            <SbSharedRefineMenuDimensionFacet
                                key={name}
                                title={localizedFilterName}
                            >
                                <SbSharedRefineMenuInputRange
                                    size={size}
                                    filterName={name}
                                    filter={dimensionFilter}
                                    applyOnBlur={applyOnBlur}
                                    statKey={measurementUnit}
                                    searchBrowse={searchBrowse}
                                    onApplyCallback={() => onApplyCallback(measurementUnit)}
                                    showInvalidRangeErrorMessage={showInvalidRangeErrorMessage}
                                />
                            </SbSharedRefineMenuDimensionFacet>
                        );
                    })}
                </React.Fragment>
            )}
        </SbSharedMeasurementUnitProvider>
    );
};

SbSharedRefineMenuInputRangeDimensionsComponent.defaultProps = {
    onApplyCallback: () => {},
};

SbSharedRefineMenuInputRangeDimensionsComponent.propTypes = {
    user: PropTypes.object,
    applyOnBlur: PropTypes.bool,
    onApplyCallback: PropTypes.func,
    filters: PropTypes.array.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    showInvalidRangeErrorMessage: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

function mapDispatchToProps(dispatch) {
    return {
        onApplyCallback(measurementUnit) {
            dispatch(
                addAndApplyFilter('measurement-unit', {
                    urlLabel: measurementUnit,
                })
            );
        },
    };
}

export const SbSharedRefineMenuInputRangeDimensions = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbSharedRefineMenuInputRangeDimensionsComponent),
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuInputRangeDimensions_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuInputRange_searchBrowse
                ...SbSharedMeasurementUnitProvider_searchBrowse
                ...SbSharedRefineMenuDimensionUnitRadioSelect_searchBrowse
            }
        `,
        filters: graphql`
            fragment SbSharedRefineMenuInputRangeDimensions_filters on SearchBrowseFilter
                @relay(plural: true) {
                name
                localizedFilterName
                values {
                    urlLabel
                    stats {
                        key
                        values
                    }
                }
            }
        `,
        user: graphql`
            fragment SbSharedRefineMenuInputRangeDimensions_user on User {
                ...SbSharedMeasurementUnitProvider_user
                ...SbSharedRefineMenuDimensionUnitRadioSelect_user
            }
        `,
    }
);
